import React, { useContext } from "react";
import { CancelConfirmationModalContainer } from "./style";
import { MyAppContext } from "../../../context/MyAppContext";
import { useIntl } from "react-intl";
import MyButton from "../../Elements/MyButton/index";
import MyModal from "../../Elements/MyModal";
import MyCancelButton from "../../Elements/MyCancelButton";
import { useMediaQuery } from "react-responsive";

const CancelConfirmationModal = () => {
  const { setCancelConfirmationPreSubscribeModal, openPreSubscribeModal } =
    useContext(MyAppContext);
  const intl = useIntl();
  const isMobile = useMediaQuery({ query: `(max-width: 768px)` });
  const isTablet = useMediaQuery({ query: `(max-width: 1000px)` });

  return (
    <MyModal
      closeModal={() => {
        // setCancelConfirmationPreSubscribeModal(false);
      }}
      headerTitle={intl.formatMessage({
        id: "MODAL.ARE_YOU_SURE",
      })}
      height="auto"
      areYouSureForm={true}
      width={isMobile || isTablet ? "300px" : "364px"}
    >
      <CancelConfirmationModalContainer>
        <div
          // className="cancel-confiramtion-text"
          dangerouslySetInnerHTML={{
            __html: intl.formatMessage({
              id: "MODAL.PRE_SUBSCRIBE.CONFIRMATION_MESSAAGE",
            }),
          }}
          style={{ textAlign: "center" }}
        />
        <MyButton
          onClick={() => {
            setCancelConfirmationPreSubscribeModal(false);
          }}
          className="continue-btn"
        >
          <b>
            {intl.formatMessage({
              id: "MODAL.CONFIRMATION.BUTTON.CONTINUE",
            })}
          </b>
        </MyButton>
        <MyCancelButton
          onClick={() => {
            openPreSubscribeModal();
            setCancelConfirmationPreSubscribeModal(false);
          }}
          className="close-btn"
        >
          <b>
            {intl.formatMessage({
              id: "MODAL.CONFIRMATION.BUTTON.CLOSE",
            })}
          </b>
        </MyCancelButton>
      </CancelConfirmationModalContainer>
    </MyModal>
  );
};

export default CancelConfirmationModal;
